import slpIcon from "./slpIcon.svg";

export { slpIcon };
